import api from '@/services/gateway/api';
import router from '@/vue-instance/router';

const state = {
  list: [],
  item: {},
  categories: [],
  tariffs: []
};

const getters = {
  getList: state => state.list,
  getItem: state => state.item,
  getCategories: state => state.categories,
  getTariffs: state => state.tariffs
};

const mutations = {
  setList (state, data) {
    state.list = data;
  },
  setItem (state, data) {
    state.item = data;
  },
  setCategories (state, data) {
    state.categories = data;
  },
  setTariffs (state, data) {
    state.tariffs = data;
  }
};

const actions = {
  getList ({ commit }, params) {
    return api.get('camp/mobile/boosters', { params })
      .then((response) => {
        commit('setList', response.data.data);
      });
  },
  getItem ({ commit }, id) {
    return api.get('camp/mobile/boosters/' + id)
      .then((response) => {
        commit('setItem', response.data);
      });
  },
  createItem ({ commit }, payload) {
    return api.post('camp/mobile/boosters', payload)
      .then(() => {
        router.push({ name: 'camp.mobile-boosters.index' });
      });
  },
  updateItem ({ commit }, { id, data }) {
    return api.post('camp/mobile/boosters/' + id, { ...data, _method: 'PUT' })
      .then(() => {
        router.push({ name: 'camp.mobile-boosters.index' });
      });
  },
  toggleVisibility ({ commit }, { id, is_active }) {
    return api.post('camp/mobile/boosters/' + id + '/visibility', { is_active, _method: 'PATCH' });
  },
  getCategories ({ commit }) {
    return api.get('camp/mobile/categories')
      .then((response) => {
        commit('setCategories', response.data.data);
      });
  },
  getTariffs ({ commit }) {
    return api.get('camp/mobile/tariffs', { params: { operator: 'MOBILE_KCELL', is_active: true } })
      .then((response) => {
        commit('setTariffs', response.data.data);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
